import { render, staticRenderFns } from "./IconAccessibility.vue?vue&type=template&id=22f72e74&"
import script from "./IconAccessibility.vue?vue&type=script&lang=ts&"
export * from "./IconAccessibility.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports